import React from 'react';
import ReactDOM from 'react-dom';

import Warn from './Warn';
import QueryUtil from './QueryUtil';

require('../styles/UserFormSetForm.css');
export default class FindForm extends React.Component
{

	static queryHistoryCache = {};

	static show(queryHandler,label,historyCacheKey,parms={})
	{
		ReactDOM.render(<FindForm parms={parms} queryHandler={queryHandler} cacheKey={historyCacheKey} label={label}/>,document.getElementById("findModal"));
		
	}

	closeHandler(focus = false)
	{
		
		let $reactComponentContainer = $("#findModal");
		ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
		$(this.modalDiv).remove();

		if(typeof(window.switchToCurrent) == "function")
			window.switchToCurrent();
	}

	query()
	{
		let filterTxt = $(this.inputFilter).val();
		if(this.props.parms && this.props.parms.type == "DateEditor")
		{
			if(filterTxt&&filterTxt.indexOf("#") != 0)
			{
				filterTxt = QueryUtil.formatDateValue(filterTxt);//FormItemDateResolver.getResult(filterTxt);
				if(filterTxt.indexOf("false:") == 0)
				{
					Warn.show({text:filterTxt.substr(6)});
					return false;
				}
			}
		}
		this.props.queryHandler(filterTxt);
		FindForm.queryHistoryCache[this.props.cacheKey] = filterTxt;
		this.closeHandler();

		var _parentWindow = (typeof(window.setOperate) == 'function')?window:window.parent.window;
		if(_parentWindow.setOperate){
			let remark ={'title':'搜索',"搜索内容":filterTxt,'搜索字段':this.props.cacheKey}
			var data ={
				'dataArea':'dynamic',
				'userId':_parentWindow.userInfos.userId,
				'userName':_parentWindow.userInfos.userName,
				'clientSessionId':_parentWindow.userInfos.userSessionId,
				'dateTime':new Date().getTime()+'',
				'operationId':'008',
				'formId':formId,
				'formDataSourceName':'',
				'formItemName':this.props.cacheKey,
				'remark':JSON.stringify(remark)
			};
			_parentWindow.setOperate(data);
		}
	}

	keyDownHandler = (e) =>
	{
		//alert("FindForm document keydown");
		if(e.keyCode == 13)
		{
			this.query();
			e.preventDefault();
			e.stopImmediatePropagation();
		}
		else if(e.keyCode == 27)
		{
			this.closeHandler(true);
			e.preventDefault();
			e.stopImmediatePropagation();
		}
	}

	componentDidMount()
	{
		if(FindForm.queryHistoryCache.hasOwnProperty(this.props.cacheKey))
		{
			$(this.inputFilter).val(FindForm.queryHistoryCache[this.props.cacheKey]);
		}
		$(this.inputFilter).focus();
		$(this.inputFilter).select();
		$(document).on("keydown",this.keyDownHandler);

		$(this.modalDiv).draggable({
			handle: ".modal-header" // 只能点击头部拖动
		}); //为模态对话框添加拖拽
	}

	componentWillUnmount()
	{
		//TODO如果没有unmountComponentAtNode手动调用，通过remove并没有调用卸载询问函数 对于该类场景 应如何设计？
		$(document).off("keydown",null,this.keyDownHandler);
	}

	findKeyDownHandler(e)
	{
		
	}

	onPasteHandler(event)
	{
		let clipboardData = (event.clipboardData || window.clipboardData);
		if(!clipboardData)return false;
		let paste = clipboardData.getData('text');
		if(!paste)return false;
		paste=paste.replace(/\r\n/g,",")  
        paste=paste.replace(/\n/g,",");  

		let val = $(this.inputFilter).val();
		if(!val)
		{
			$(this.inputFilter).val(paste);
		}
		else
		{
			let selectionStart = this.inputFilter.selectionStart;
			let selectionEnd = this.inputFilter.selectionEnd;

			$(this.inputFilter).val(val.substr(0,selectionStart) + paste + val.substr(selectionEnd));
		}
		
		event.preventDefault();
	}

	getInputFilterDom()
	{
		if(this.props.parms && this.props.parms.type == "StringEditor")
			return <input onPaste={this.onPasteHandler.bind(this)} autoComplete="on" spellCheck="false" type="text" style={{width:"200px",marginRight:"10px",width:'308px',height:'28px',background:'#FFFFFF',border:'1px solid #C4C6CF',borderRadius:'1px'}} ref={node => this.inputFilter = node}/>;

		return <input autoComplete="on" spellCheck="false" type="text" style={{width:"200px",marginRight:"10px",width:'308px',height:'28px',background:'#FFFFFF',border:'1px solid #C4C6CF',borderRadius:'1px'}} ref={node => this.inputFilter = node}/>;
		
	}

	render()
	{
		let inputFilterDom = this.getInputFilterDom();
		return 	(<div className="modal" style={{display:"flex",justifyContent:"center"}} ref={node => this.modalDiv = node} onKeyDown={this.findKeyDownHandler.bind(this)}>
					<div style={{alignSelf:"center",borderRadius:"2px",width:'508px',height:'137px',display:'flex',flexDirection:'column',background:'#FFFFFF',border:'0 solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px'}}>
		              <div className="modal-header" style={{display:"flex",flexDirection:"row",position:"relative",width:"auto",alignItems:"center",paddingLeft:"2px",position:"relative"}}>
					  	<h5 className="modal-title" style={{paddingLeft:'23px',fontFamily:'STSongti-SC-Bold',fontSize:'16px',color:'#000000'}}>查找</h5>
						<div className="modal-close" onClick={this.closeHandler.bind(this)}></div>
		              </div>
		              <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexGrow:'1'}}>
					  	<h5 style={{fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingRight:'10px'}}>{this.props.label}</h5>
					  	{inputFilterDom}
						<button type="button" className="btn btn-info ufs-require" style={{height:'28px',marginRight:'0px',width:'80px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',color:'#fff'}} onClick={this.query.bind(this)}>查找</button>
					  </div>
					</div>
		         </div>
		        );
	}
}


// WEBPACK FOOTER //
// ./src/utils/FindForm.js